import React from "react";
import { Icon } from "@alifd/next";
import styles from "./index.module.scss";

import TagRadio from "../Nodes/TagRadio";
import TagCheckbox from "../Nodes/TagCheckbox";
import TagProvince from "../Nodes/TagProvince";
import TagSlider from "../Nodes/TagSlider";
import TagSection from "../Nodes/TagSection";
import TagTime from "../Nodes/TagTime";
import TagCategories from "../Nodes/TagCategories";
import TagCrowd from "../Nodes/TagCrowd";
import TagSku from "../Nodes/TagSku";

interface CrowdLabel {
  id: string;
  labelName?: string;
  labelDescription?: string;
  label_desc?: string;
  valueType: number;
  crowdLabels?: Array<{
    id: string;
    labelDescription: string;
    valueType: number;
    value?: any;
    selectedValue?: any;
    selectSecondVal?: any;
  }>;
}

interface ActiveTagItem extends CrowdLabel {}

const arr = [TagRadio, TagCheckbox, TagProvince, TagSlider, TagSection, TagTime, TagCategories, TagCrowd, TagSku];

interface SubPageProps {
  contItem: ActiveTagItem;
  contIndex: number;
  changeActiveList: (contItem: ActiveTagItem, contIndex: number, item: any, index: number, subItem: any, subIndex: number) => void;
  changeActiveTagValue:  (newData: any,contItem: ActiveTagItem,contIndex: number) => void;
}

const SubPage: React.FC<SubPageProps> = ({ contItem, contIndex, changeActiveList, changeActiveTagValue }) => {
  const Content = arr[contItem.valueType - 1];
  return (
    <div key={contItem.id} className={`${styles.mb10}`}>
      <section className={`${styles["tag-name"]}`} style={{ position: "relative" }}>
        {contItem.labelDescription}-&gt;
        <span className={`${styles["tag-desc"]}`}>{contItem.label_desc}</span>
        <Icon
          onClick={(event) => {
            changeActiveList(contItem, contIndex, contItem, contIndex, null, 0);
          }}
          type="close"
          size="xs"
          style={{
            cursor: "pointer",
            position: "absolute",
            top: "10px",
            right: "15px",
          }}
        />
      </section>
      <div className={`${styles["editTag-content"]}`}>
        <Content tagItem={contItem} changeData={(newData) => changeActiveTagValue( newData,contItem,contIndex,)} />
      </div>
    </div>
  );
};

const TagMapping: React.FC<{
  activeTagList: ActiveTagItem[];
  changeActiveTagValue: ( newData: any,contItem: ActiveTagItem,contIndex: number,) => void;
  changeActiveList: (contItem: ActiveTagItem, contIndex: number, item: any, index: number, subItem: any, subIndex: number) => void;
}> = ({ activeTagList = [], changeActiveTagValue = () => {}, changeActiveList = () => {} }) => {
  return (
    <>
      {activeTagList.map((contItem, contIndex) => (
        <div key={`contItem_${contIndex}`}>
          {/* <div className={`${styles["tag-title"]}`}>{contItem.labelName}</div> */}
          <section className={`${styles["tag-content"]}`}>
            
            <SubPage
              contItem={contItem}
              contIndex={contIndex}
              changeActiveList={changeActiveList}
              changeActiveTagValue={changeActiveTagValue}
            />
          </section>
        </div>
      ))}
    </>
  );
};

export default TagMapping;